<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="12">
        <payorList></payorList>
      </el-col>
      <el-col :span="12">
        <payorDetailList></payorDetailList>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import payorList from './payorList.vue'
  import payorDetailList from './payorDetailList.vue'

  export default {
    name: 'payors',
    data() {
      return {
      }
    },
    components: {
      payorDetailList,
      payorList
    }
  }
</script>
